import React, { useEffect, useState, useRef } from "react";
import MapComponent from "../common-pointr-map-container/GenericPointrMapContainer"
import LeftContainer from "../left-container/left-container";
import HeaderContainer from "../header-container/header-container";
import RightContainer from "../right-container/right-container";
import SearchPopup from '../main-container/SearchPopup'; // Import SearchPopup component
import FooterContainer from '../footer-container/footer-container';
import { useMap } from '../../../context/MapContext'; // Import the useMap hook
import { useLocation } from 'react-router-dom'; // Import useLocation hook
import { handleReset } from '../main-container/handleResetView'; // Import the functions
import { calculateMidPoint, manageLayers,markCurrentPosition, removeCurrentPosition } from '../main-container/markCurrentPosition'; // Import the functions
import { fetchGsxData } from '../left-container/fetchZonesHubwalksInfo';
import CustomPopup from '../main-container/DirectionPopup';
import ciscoSpacesPopupIcon from '../../../../assets/images/powered-by-spaces-cl-amer.png';
import Screensaver from "../countdown-timer-container/screensaver";
import ciscoSpacesPopupImage from '../../../../assets/images/cisco-space-popup-cl-amer.png';
import {handleWhereAmI} from '../footer-container/handle-where-am-i';  
import ciscoAILogo from '../../../../assets/images/ai/ai-logo.svg';
import ciscoAIQrPlaceHolderLogo from '../../../../assets/images/ai/qr-code-place-holder.svg';
import ciscoAIQrPlaceHolderFailedLogo from '../../../../assets/images/ai/qr-code-place-holder-failed.svg';

import ciscoClosebutton from '../../../../assets/images/close-button.svg';
import ciscoHelpbutton from '../../../../assets/images/ai/help-icon.svg';
import CiscoAiAuth from '../right-container/ciscoAiAuth';
import {fetchAttendeeInfo, fetchRecommendedEvents} from '../right-container/ciscoAiApis';
import { TeaLogService,TeaLogModule } from '@events/tealium';
import {initializeXAPIScanner, getHashes} from '../qr-code-scanner-component/qr-code-scanner';
import AIFAQListContainer from "../right-container/ai-faq-list";
import {sendTrackingEventForCiscoAI} from "../main-container/pendoApis"
const CiscoGSX2025MainContainer = () => {
  const kioskData = {
    "1": {
      "lat": 32.70692347149814,
      "long":  -117.16112071197011,
      "rotation": 1.5,
      "bearing": -83.8,
      "building": 13,
      "level":0
    },
    "2": {
      "lat":52.34304739930653,
      "long": 4.889270989661952,
      "rotation": 1.5,
      "bearing": -83.5,
      "building": 8,
      "level":0
    },
    "3": {
      "lat": 52.34291789711398,
      "long": 4.889002347549763,
      "rotation": -0.1,
      "bearing": 7.7,
      "building": 8,
      "level": 0
    },
    "4": {
      "lat": 52.342938641773316,
      "long": 4.88863391263547,
      "rotation": -0.1,
      "bearing": 7.3,
      "building": 8,
      "level": 0
    },
    "5": {
      "lat": 52.34270049580422,
      "long": 4.888281210174,
      "rotation": -2.4,
      "bearing": 138.8,
      "building": 8,
      "level": 0
    },
    "6": {
      "lat": 52.3417931366011,
      "long": 4.889853488005201,
      "rotation": 3,
      "bearing": -173,
      "building": 8,
      "level": 0
    },
    "7": {
      "lat": 52.3421907282972,
      "long": 4.889933315632021,
      "rotation": 1.5,
      "bearing": -85.19,
      "building": 8,
      "level": 0
    },
    "8": {
      "lat": 52.34218811829402,
      "long": 4.889891267993676,
      "rotation": -1.6,
      "bearing": 99.5,
      "building": 8,
      "level": 0
    },
    "9": {
      "lat": 52.34247223116844,
      "long": 4.889034164062082,
      "rotation": -0.1,
      "bearing": 7.6,
      "building": 8,
      "level": 0
    },
    "10": {
      "lat": 52.34246884041784,
      "long": 4.887584477600029,
      "rotation": 1.4,
      "bearing": -82.7,
      "building": 8,
      "level": 0
    },
    "11": {
      "lat": 52.34337612375032,
      "long": 4.888238811682442,
      "rotation": -2.5,
      "bearing": 141.2,
      "building": 8,
      "level": 0
    },
    "12": {
      "lat": 52.342679076470716,
      "long": 4.886921036031765,
      "rotation": -1.6,
      "bearing": 93.2,
      "building": 8,
      "level": 0
    },
    "13": {
      "lat": 52.34076464918098,
      "long":  4.88584073306842,
      "rotation": -0.01,
      "bearing": 7.9,
      "building": 8,
      "level": 0
    },
    "14": {
      "lat": 52.34153488944142,
      "long": 4.887946330152886,
      "rotation": 1.2,
      "bearing": -70,
      "building": 8,
      "level": 1
    },
    "15": {
      "lat": 52.34153488944142,
      "long": 4.887946330152886,
      "rotation": 1.2,
      "bearing": -70,
      "building": 8,
      "level": 1
    },
    "16": {
      "lat": 52.340483321407646,
      "long": 4.8894760863031195,
      "rotation": 1.5,
      "bearing": -84.2,
      "building": 8,
      "level": 1
    }
  };
  
  const { map } = useMap();
  const teaLogService = new TeaLogService();

  const [isActive, setIsActive] = useState(true);
  const [timer, setTimer] = useState(null);
  const [showSearch, setShowSearch] = useState(false);
  const [searchInput, setSearchInput] = useState('');
  const [isMapLoaded, setIsMapLoaded] = useState(false);
  const [isZonesInfoPopulated, setIsZonesInfoPopulated] = useState(false);

  const [zonesInfo, setZonesInfo] = useState([]);
  const [hubwalksInfo, setHubwalksInfo] = useState([]);
  const [facilitiesData, setFacilitiesData] = useState([]);
  const [recommendationsInfo, setRecommendationsInfo] = useState([]);
  const [attendeeUserToken, setAttendeeUserToken] = useState([]);
  const [attendeeInfo, setAttendeeInfo] = useState([]);

  const hasPassedDestFidRef = useRef(false);

  const timerRef = useRef(null);
  const [popupState, setPopupState] = useState({ poi: null, coordinates: null }); // Add state for the popup
  const [ciscoSpacesPopup, setCiscoSpacesPopup] = useState(false);
  const [showPopupCard, setShowPopupCard] = useState(false);
  const [showFaqList, setShowFaqList] = useState(false);
  const [qrScanBadgeInfoInput, setQRScanBadgeInfoInput] = useState(null);
  const [aiLoader, showAiLoader] = useState(false);
  const [showFailedPopupCard, setShowFailedPopupCard] = useState(false);

  
  
  const [showAICard, setShowAICard] = useState(false);

  const [isPointrSDKLoaded, setIsPointrSDKLoaded] = useState(false); // State to track Pointr SDK load status
  const [triggerDirectionsPopup, setTriggerDirectionsPopup] = useState(false);

  const tenantId = "263256";
  const locationId = "f1b281fa-c996-4a01-b746-f3e763f438a8";
  const siteExternalIdentifier = "885cb255-910f-48d1-8e92-de4f5ad4575d";
  const timeZoneCity = "Las Vegas"
  const timeZone = "America/Los_Angeles"

  const eventLogoName = "cisco-gsx-logo.svg"
  const eventName = "GSX"
  const qrCodeExpiresAt = 1752623999 // July 15 2025
  const eventId="ds1ciscolive25";
  const eventTitle = "Las Vegas"
  const defaultBuildingTitle = "Las Vegas" 
  const eventSubTitle = ""
  const timeZoneDiff = -7

  const buildingInfo = [
    {
        "buildingTitle": "Cisco - GSX 2025",
        "buildingInternalIdentifier": 22,
        "buildingExternalIdentifier": "f1b281fa-c996-4a01-b746-f3e763f438a8",
        "buildingExtraData": {
            "timeZone": "America/Los_Angeles"
        },
        "geometry": {
            "type": "Polygon",
            "coordinates": [
                [
                    [
                        -115.178345,
                        36.08940851
                    ],
                    [
                        -115.17834507,
                        36.08938519
                    ],
                    [
                        -115.17834338,
                        36.08938519
                    ],
                    [
                        -115.1783435,
                        36.08934677
                    ],
                    [
                        -115.1783452,
                        36.08934677
                    ],
                    [
                        -115.17834521,
                        36.08934294
                    ],
                    [
                        -115.17834521,
                        36.0893429
                    ],
                    [
                        -115.17834521,
                        36.08934286
                    ],
                    [
                        -115.17834534,
                        36.08930286
                    ],
                    [
                        -115.17834364,
                        36.08930286
                    ],
                    [
                        -115.17834377,
                        36.08926444
                    ],
                    [
                        -115.17834547,
                        36.08926444
                    ],
                    [
                        -115.17834566,
                        36.08920681
                    ],
                    [
                        -115.17836433,
                        36.08920685
                    ],
                    [
                        -115.17836445,
                        36.08917254
                    ],
                    [
                        -115.17836448,
                        36.08916248
                    ],
                    [
                        -115.1783645,
                        36.08915607
                    ],
                    [
                        -115.17832884,
                        36.089156
                    ],
                    [
                        -115.17832884,
                        36.08915737
                    ],
                    [
                        -115.17830851,
                        36.08915733
                    ],
                    [
                        -115.17830846,
                        36.08915733
                    ],
                    [
                        -115.17829063,
                        36.08915729
                    ],
                    [
                        -115.17829058,
                        36.08915729
                    ],
                    [
                        -115.17826893,
                        36.08915725
                    ],
                    [
                        -115.17825161,
                        36.08915721
                    ],
                    [
                        -115.17825157,
                        36.08915721
                    ],
                    [
                        -115.17825152,
                        36.08915721
                    ],
                    [
                        -115.17824818,
                        36.0891572
                    ],
                    [
                        -115.17824815,
                        36.08916543
                    ],
                    [
                        -115.17823032,
                        36.08916539
                    ],
                    [
                        -115.17823033,
                        36.08916402
                    ],
                    [
                        -115.17804354,
                        36.08916363
                    ],
                    [
                        -115.17804353,
                        36.089165
                    ],
                    [
                        -115.17802655,
                        36.08916496
                    ],
                    [
                        -115.17802658,
                        36.08915673
                    ],
                    [
                        -115.17802148,
                        36.08915672
                    ],
                    [
                        -115.17802148,
                        36.08915635
                    ],
                    [
                        -115.17794677,
                        36.08915619
                    ],
                    [
                        -115.1779196,
                        36.08915613
                    ],
                    [
                        -115.17784489,
                        36.08915597
                    ],
                    [
                        -115.1777914,
                        36.08915586
                    ],
                    [
                        -115.17774385,
                        36.08915575
                    ],
                    [
                        -115.17772638,
                        36.08915572
                    ],
                    [
                        -115.17772607,
                        36.08915567
                    ],
                    [
                        -115.17772579,
                        36.08915553
                    ],
                    [
                        -115.17772557,
                        36.08915531
                    ],
                    [
                        -115.17772543,
                        36.08915503
                    ],
                    [
                        -115.17772538,
                        36.08915472
                    ],
                    [
                        -115.17772584,
                        36.08901378
                    ],
                    [
                        -115.17761781,
                        36.08901355
                    ],
                    [
                        -115.17757875,
                        36.08901347
                    ],
                    [
                        -115.17753121,
                        36.08901336
                    ],
                    [
                        -115.17753128,
                        36.08898964
                    ],
                    [
                        -115.17752279,
                        36.08898962
                    ],
                    [
                        -115.17752281,
                        36.08898276
                    ],
                    [
                        -115.17752112,
                        36.08898275
                    ],
                    [
                        -115.17752131,
                        36.08892238
                    ],
                    [
                        -115.17752301,
                        36.08892238
                    ],
                    [
                        -115.17752303,
                        36.08891552
                    ],
                    [
                        -115.17753152,
                        36.08891554
                    ],
                    [
                        -115.17753155,
                        36.0889073
                    ],
                    [
                        -115.17752306,
                        36.08890728
                    ],
                    [
                        -115.17752309,
                        36.08889768
                    ],
                    [
                        -115.17752139,
                        36.08889768
                    ],
                    [
                        -115.17752157,
                        36.08884279
                    ],
                    [
                        -115.17752327,
                        36.08884279
                    ],
                    [
                        -115.17752329,
                        36.08883639
                    ],
                    [
                        -115.17753801,
                        36.08883642
                    ],
                    [
                        -115.17753806,
                        36.08881995
                    ],
                    [
                        -115.17752334,
                        36.08881992
                    ],
                    [
                        -115.17752335,
                        36.08881763
                    ],
                    [
                        -115.17752165,
                        36.08881763
                    ],
                    [
                        -115.17752178,
                        36.08877921
                    ],
                    [
                        -115.17752348,
                        36.08877921
                    ],
                    [
                        -115.17752349,
                        36.08877418
                    ],
                    [
                        -115.17753198,
                        36.0887742
                    ],
                    [
                        -115.17753235,
                        36.0886603
                    ],
                    [
                        -115.17752386,
                        36.08866029
                    ],
                    [
                        -115.17752389,
                        36.08865297
                    ],
                    [
                        -115.17752219,
                        36.08865296
                    ],
                    [
                        -115.17752231,
                        36.08861454
                    ],
                    [
                        -115.17752401,
                        36.08861454
                    ],
                    [
                        -115.17752403,
                        36.08860906
                    ],
                    [
                        -115.17753252,
                        36.08860907
                    ],
                    [
                        -115.17753262,
                        36.08857843
                    ],
                    [
                        -115.17752413,
                        36.08857841
                    ],
                    [
                        -115.17752415,
                        36.08857109
                    ],
                    [
                        -115.17752246,
                        36.08857109
                    ],
                    [
                        -115.17752265,
                        36.08851071
                    ],
                    [
                        -115.17752435,
                        36.08851071
                    ],
                    [
                        -115.17752437,
                        36.08850385
                    ],
                    [
                        -115.17753286,
                        36.08850387
                    ],
                    [
                        -115.17753289,
                        36.08849564
                    ],
                    [
                        -115.1775244,
                        36.08849562
                    ],
                    [
                        -115.17752442,
                        36.08848876
                    ],
                    [
                        -115.17752272,
                        36.08848875
                    ],
                    [
                        -115.17752292,
                        36.08842838
                    ],
                    [
                        -115.17752462,
                        36.08842838
                    ],
                    [
                        -115.17752464,
                        36.08842152
                    ],
                    [
                        -115.17753313,
                        36.08842154
                    ],
                    [
                        -115.17753316,
                        36.0884133
                    ],
                    [
                        -115.17752467,
                        36.08841328
                    ],
                    [
                        -115.1775247,
                        36.08840368
                    ],
                    [
                        -115.177523,
                        36.08840368
                    ],
                    [
                        -115.17752318,
                        36.08834879
                    ],
                    [
                        -115.17752488,
                        36.08834879
                    ],
                    [
                        -115.17752491,
                        36.08833918
                    ],
                    [
                        -115.1775334,
                        36.0883392
                    ],
                    [
                        -115.17753343,
                        36.08833097
                    ],
                    [
                        -115.17752494,
                        36.08833095
                    ],
                    [
                        -115.17752496,
                        36.08832363
                    ],
                    [
                        -115.17752326,
                        36.08832363
                    ],
                    [
                        -115.17752339,
                        36.08828521
                    ],
                    [
                        -115.17752509,
                        36.08828521
                    ],
                    [
                        -115.1775251,
                        36.08828018
                    ],
                    [
                        -115.17753359,
                        36.0882802
                    ],
                    [
                        -115.17753377,
                        36.08822531
                    ],
                    [
                        -115.17752528,
                        36.08822529
                    ],
                    [
                        -115.1775253,
                        36.08822026
                    ],
                    [
                        -115.1775236,
                        36.08822025
                    ],
                    [
                        -115.17752372,
                        36.08818187
                    ],
                    [
                        -115.17752372,
                        36.08818183
                    ],
                    [
                        -115.17752372,
                        36.0881818
                    ],
                    [
                        -115.17752401,
                        36.08809492
                    ],
                    [
                        -115.17752231,
                        36.08809492
                    ],
                    [
                        -115.17752238,
                        36.08807296
                    ],
                    [
                        -115.17753427,
                        36.08807299
                    ],
                    [
                        -115.17753428,
                        36.08806796
                    ],
                    [
                        -115.17754457,
                        36.08806798
                    ],
                    [
                        -115.17754457,
                        36.08806608
                    ],
                    [
                        -115.17754767,
                        36.08806559
                    ],
                    [
                        -115.1775477,
                        36.08805644
                    ],
                    [
                        -115.1775477,
                        36.08805644
                    ],
                    [
                        -115.17754771,
                        36.08805167
                    ],
                    [
                        -115.17754771,
                        36.08805163
                    ],
                    [
                        -115.17754771,
                        36.08805159
                    ],
                    [
                        -115.17754773,
                        36.08804641
                    ],
                    [
                        -115.17754774,
                        36.08804253
                    ],
                    [
                        -115.17754774,
                        36.08804249
                    ],
                    [
                        -115.17754774,
                        36.08804245
                    ],
                    [
                        -115.17754777,
                        36.08803494
                    ],
                    [
                        -115.17754777,
                        36.08803494
                    ],
                    [
                        -115.17754778,
                        36.08803338
                    ],
                    [
                        -115.1775478,
                        36.08802579
                    ],
                    [
                        -115.1775478,
                        36.08802579
                    ],
                    [
                        -115.17754781,
                        36.08802103
                    ],
                    [
                        -115.17754781,
                        36.08802099
                    ],
                    [
                        -115.17754781,
                        36.08802096
                    ],
                    [
                        -115.17754784,
                        36.08801184
                    ],
                    [
                        -115.17754475,
                        36.08801133
                    ],
                    [
                        -115.17754476,
                        36.08800943
                    ],
                    [
                        -115.17753447,
                        36.08800941
                    ],
                    [
                        -115.17753449,
                        36.08800438
                    ],
                    [
                        -115.1775226,
                        36.08800435
                    ],
                    [
                        -115.17752265,
                        36.08799063
                    ],
                    [
                        -115.17752435,
                        36.08799063
                    ],
                    [
                        -115.17752457,
                        36.08792202
                    ],
                    [
                        -115.17752287,
                        36.08792202
                    ],
                    [
                        -115.17752288,
                        36.08792065
                    ],
                    [
                        -115.17752118,
                        36.08792064
                    ],
                    [
                        -115.1775212,
                        36.08791241
                    ],
                    [
                        -115.17751611,
                        36.0879124
                    ],
                    [
                        -115.17751611,
                        36.08791103
                    ],
                    [
                        -115.1774414,
                        36.08791087
                    ],
                    [
                        -115.17741083,
                        36.0879108
                    ],
                    [
                        -115.17730895,
                        36.08791059
                    ],
                    [
                        -115.17726989,
                        36.0879105
                    ],
                    [
                        -115.17724952,
                        36.08791046
                    ],
                    [
                        -115.17722971,
                        36.08791042
                    ],
                    [
                        -115.17722991,
                        36.08784683
                    ],
                    [
                        -115.17722995,
                        36.08783677
                    ],
                    [
                        -115.17722997,
                        36.08782831
                    ],
                    [
                        -115.1772343,
                        36.08782832
                    ],
                    [
                        -115.17723431,
                        36.0878283
                    ],
                    [
                        -115.17723332,
                        36.08782763
                    ],
                    [
                        -115.17723332,
                        36.08782763
                    ],
                    [
                        -115.17723336,
                        36.0878253
                    ],
                    [
                        -115.17723456,
                        36.08776277
                    ],
                    [
                        -115.17723427,
                        36.08776272
                    ],
                    [
                        -115.17723399,
                        36.08776258
                    ],
                    [
                        -115.17723377,
                        36.08776236
                    ],
                    [
                        -115.17723363,
                        36.08776208
                    ],
                    [
                        -115.17723358,
                        36.08776177
                    ],
                    [
                        -115.17723521,
                        36.08725778
                    ],
                    [
                        -115.17723611,
                        36.08698114
                    ],
                    [
                        -115.1772381,
                        36.08698014
                    ],
                    [
                        -115.17731358,
                        36.0869803
                    ],
                    [
                        -115.17744103,
                        36.08698057
                    ],
                    [
                        -115.17744303,
                        36.08698057
                    ],
                    [
                        -115.17754292,
                        36.08698079
                    ],
                    [
                        -115.17754492,
                        36.08698002
                    ],
                    [
                        -115.17754492,
                        36.08698079
                    ],
                    [
                        -115.17773959,
                        36.0869812
                    ],
                    [
                        -115.17774159,
                        36.08698121
                    ],
                    [
                        -115.17783435,
                        36.08698141
                    ],
                    [
                        -115.17783635,
                        36.08698141
                    ],
                    [
                        -115.17802629,
                        36.08698181
                    ],
                    [
                        -115.17802829,
                        36.08698182
                    ],
                    [
                        -115.17809416,
                        36.08698196
                    ],
                    [
                        -115.17809416,
                        36.08698156
                    ],
                    [
                        -115.17809616,
                        36.08698196
                    ],
                    [
                        -115.1781053,
                        36.08698199
                    ],
                    [
                        -115.17810562,
                        36.08698204
                    ],
                    [
                        -115.1781059,
                        36.08698219
                    ],
                    [
                        -115.17810612,
                        36.08698242
                    ],
                    [
                        -115.17810618,
                        36.08698254
                    ],
                    [
                        -115.17810711,
                        36.08698254
                    ],
                    [
                        -115.17810711,
                        36.08698254
                    ],
                    [
                        -115.17810711,
                        36.08698254
                    ],
                    [
                        -115.17818228,
                        36.0869827
                    ],
                    [
                        -115.17818228,
                        36.0869827
                    ],
                    [
                        -115.17818259,
                        36.08698278
                    ],
                    [
                        -115.17818312,
                        36.08698291
                    ],
                    [
                        -115.17818313,
                        36.08698287
                    ],
                    [
                        -115.17819225,
                        36.08698417
                    ],
                    [
                        -115.17835222,
                        36.08702435
                    ],
                    [
                        -115.17835335,
                        36.08702715
                    ],
                    [
                        -115.17835292,
                        36.08716129
                    ],
                    [
                        -115.17835234,
                        36.08716354
                    ],
                    [
                        -115.17841338,
                        36.08730557
                    ],
                    [
                        -115.17841418,
                        36.08730742
                    ],
                    [
                        -115.17842724,
                        36.08733782
                    ],
                    [
                        -115.17843714,
                        36.08736087
                    ],
                    [
                        -115.17845862,
                        36.08741086
                    ],
                    [
                        -115.17845942,
                        36.08741271
                    ],
                    [
                        -115.17848726,
                        36.08747749
                    ],
                    [
                        -115.17848805,
                        36.08747934
                    ],
                    [
                        -115.1785209,
                        36.08755579
                    ],
                    [
                        -115.1785217,
                        36.08755764
                    ],
                    [
                        -115.17852347,
                        36.08756177
                    ],
                    [
                        -115.17857232,
                        36.08767544
                    ],
                    [
                        -115.17857311,
                        36.08767729
                    ],
                    [
                        -115.1785861,
                        36.08770751
                    ],
                    [
                        -115.17860588,
                        36.08775354
                    ],
                    [
                        -115.17860668,
                        36.08775539
                    ],
                    [
                        -115.178655,
                        36.08786783
                    ],
                    [
                        -115.17865579,
                        36.08786968
                    ],
                    [
                        -115.17868774,
                        36.08794404
                    ],
                    [
                        -115.17868855,
                        36.08794589
                    ],
                    [
                        -115.17873902,
                        36.08806336
                    ],
                    [
                        -115.17873982,
                        36.08806521
                    ],
                    [
                        -115.17876721,
                        36.08812896
                    ],
                    [
                        -115.17876729,
                        36.08812927
                    ],
                    [
                        -115.17876726,
                        36.0881296
                    ],
                    [
                        -115.17876712,
                        36.0881299
                    ],
                    [
                        -115.1787669,
                        36.08813014
                    ],
                    [
                        -115.17876668,
                        36.08813026
                    ],
                    [
                        -115.17878984,
                        36.08818413
                    ],
                    [
                        -115.1787942,
                        36.08819428
                    ],
                    [
                        -115.17879463,
                        36.08819428
                    ],
                    [
                        -115.17879492,
                        36.08819432
                    ],
                    [
                        -115.17879518,
                        36.08819445
                    ],
                    [
                        -115.1787954,
                        36.08819464
                    ],
                    [
                        -115.17879555,
                        36.08819489
                    ],
                    [
                        -115.17882421,
                        36.0882616
                    ],
                    [
                        -115.17882508,
                        36.0882636
                    ],
                    [
                        -115.17882677,
                        36.08826755
                    ],
                    [
                        -115.17882685,
                        36.08826794
                    ],
                    [
                        -115.17882685,
                        36.08826819
                    ],
                    [
                        -115.1788269,
                        36.08826821
                    ],
                    [
                        -115.17882712,
                        36.08826843
                    ],
                    [
                        -115.17882726,
                        36.08826871
                    ],
                    [
                        -115.17882731,
                        36.08826902
                    ],
                    [
                        -115.17882714,
                        36.08832196
                    ],
                    [
                        -115.17882613,
                        36.08832397
                    ],
                    [
                        -115.17882587,
                        36.08840538
                    ],
                    [
                        -115.17882599,
                        36.08840544
                    ],
                    [
                        -115.17882621,
                        36.08840566
                    ],
                    [
                        -115.17882635,
                        36.08840594
                    ],
                    [
                        -115.1788264,
                        36.08840625
                    ],
                    [
                        -115.17882612,
                        36.08849305
                    ],
                    [
                        -115.17882612,
                        36.08849505
                    ],
                    [
                        -115.178826,
                        36.08852959
                    ],
                    [
                        -115.17882563,
                        36.08864438
                    ],
                    [
                        -115.17882563,
                        36.08864638
                    ],
                    [
                        -115.17882558,
                        36.08866074
                    ],
                    [
                        -115.17882537,
                        36.08872561
                    ],
                    [
                        -115.17882536,
                        36.08872761
                    ],
                    [
                        -115.17882517,
                        36.08878758
                    ],
                    [
                        -115.17882514,
                        36.08879497
                    ],
                    [
                        -115.17882514,
                        36.08879697
                    ],
                    [
                        -115.17882511,
                        36.08880642
                    ],
                    [
                        -115.17882493,
                        36.08886105
                    ],
                    [
                        -115.17882492,
                        36.08886305
                    ],
                    [
                        -115.17882478,
                        36.08890734
                    ],
                    [
                        -115.17882474,
                        36.08891778
                    ],
                    [
                        -115.17882474,
                        36.08891978
                    ],
                    [
                        -115.17882458,
                        36.08896683
                    ],
                    [
                        -115.17882471,
                        36.08896689
                    ],
                    [
                        -115.17882495,
                        36.08896711
                    ],
                    [
                        -115.17882511,
                        36.0889674
                    ],
                    [
                        -115.17882516,
                        36.08896772
                    ],
                    [
                        -115.17882514,
                        36.08897533
                    ],
                    [
                        -115.17882514,
                        36.08897733
                    ],
                    [
                        -115.17882487,
                        36.08905791
                    ],
                    [
                        -115.17882487,
                        36.08905991
                    ],
                    [
                        -115.17882471,
                        36.08910492
                    ],
                    [
                        -115.17882465,
                        36.08910525
                    ],
                    [
                        -115.17882449,
                        36.08910554
                    ],
                    [
                        -115.17882425,
                        36.08910576
                    ],
                    [
                        -115.17882413,
                        36.08910581
                    ],
                    [
                        -115.17882392,
                        36.08916746
                    ],
                    [
                        -115.17882392,
                        36.08916946
                    ],
                    [
                        -115.17882365,
                        36.08924989
                    ],
                    [
                        -115.17889163,
                        36.08925003
                    ],
                    [
                        -115.17889194,
                        36.08925008
                    ],
                    [
                        -115.17889222,
                        36.08925022
                    ],
                    [
                        -115.17889244,
                        36.08925044
                    ],
                    [
                        -115.17889258,
                        36.08925072
                    ],
                    [
                        -115.17889263,
                        36.08925103
                    ],
                    [
                        -115.17889214,
                        36.08939923
                    ],
                    [
                        -115.17889209,
                        36.08939954
                    ],
                    [
                        -115.17889195,
                        36.08939982
                    ],
                    [
                        -115.17889173,
                        36.08940004
                    ],
                    [
                        -115.17889153,
                        36.08940965
                    ],
                    [
                        -115.17889153,
                        36.08940965
                    ],
                    [
                        -115.178345,
                        36.08940851
                    ]
                ]
            ]
        },
        "levels": [
            {
                "levelShortTitle": "L1",
                "levelLongTitle": "First Floor",
                "levelIndex": 0,
                "levelExtraData": {
                    "levelType": "exhibition",
                    "timeZone": "America/Los_Angeles",
                    "levelExternalIdentifier": "7ef90a9c-cb0d-4ef5-9804-db628f036250"
                }
            }
        ]
    }

  ];
  const buildingExID = {
    0: "f1b281fa-c996-4a01-b746-f3e763f438a8"
  };
  const levelExId ={
    "f1b281fa-c996-4a01-b746-f3e763f438a8":{
      1: "7ef90a9c-cb0d-4ef5-9804-db628f036250"
    }
  }

  const minMaxBounds = [
    
    [ 4.874747373780906,
      52.32649719537784
    ],
    [
      4.900164974144076,
      52.35777235234855
    ]
  ];

  const floorNameMapping = {
    0: 'Mezzanine Level'
  };

  const floorColourMapping = [
    { levelIndex: 0, color: '#0FC097' },
    { levelIndex: 1, color: '#FFB327' },
    { levelIndex: 2, color: '#0099F7' },
    { levelIndex: 3, color: '#FF468F' },
    { levelIndex: 4, color: '#8F29BE' },
    { levelIndex: 5, color: '#BBDFFF' },
  ];

  const constraintsLookUp =  {
    "Full Conference": [
        "Full Conf - Schedule",
        "Explorer - Schedule"
    ],
    "Cisco Employee Full Conference": [
        "Full Conf - Schedule",
        "Explorer - Schedule"
    ],
    "IT Leadership": [
        "Full Conf - Schedule",
        "Explorer - Schedule"
    ],
    "Explorer": [
        "Full Conf - View",
        "Explorer - Schedule"
    ],
    "Cisco Explorer": [
        "Full Conf - View",
        "Explorer - Schedule"
    ],
    "Event Staff": [
        "Full Conf - View"
    ],
    "Executive Symposium": [
        "Full Conf - Schedule",
        "Explorer - Schedule"
    ],
    "Cisco Speaker Pass": [
        "Full Conf - View"
    ],
    "Executive Full Conference": [
        "Full Conf - View",
        "Explorer - Schedule"
    ],
    "Technical Seminar#1": [
        "Full Conf - View",
        "Explorer - Schedule"
    ],
    "Technical Seminar#2": [
        "Full Conf - View",
        "Explorer - Schedule"
    ]
};
 
  const getLocationId = (poi) => {
    const bid = poi?.properties?.bid;
    const lvl = poi?.properties?.lvl;
    const buildingId = buildingExID[bid];
  
    // Check if both buildingId and lvl exist in levelExId
    if (buildingId && lvl !== undefined && levelExId[buildingId]?.[lvl] !== undefined) {
      return levelExId[buildingId][lvl];
    }
  
    // Fallback to buildingId if lvl is not present or no match found
    return buildingId || locationId;
  };
  const useQuery = () => {
    return new URLSearchParams(useLocation().search);
  };
  const query = useQuery();
  const kioskFid = query.get('kioskFid')||query.get('locationNum');
  const destFid = query.get('destFid');
  const latFromQuery = parseFloat(query.get('lat'));
  const longFromQuery = parseFloat(query.get('long'));
  const rotationFromQuery = parseFloat(query.get('rotation'));
  const zoomFromQuery = parseFloat(query.get('zoom'));
  const pitchFromQuery = parseFloat(query.get('pitch'));
  const bearingFromQuery = parseFloat(query.get('bearing'));
  const levelFromQuery = parseFloat(query.get('level'));
  const buildingFromQuery = parseFloat(query.get('building'));
  const visibleAiContainerFromQuery = query.get('enableAI');
  const eventStartDay = query.get('eventStartDay')?query.get('eventStartDay'):26;
  const signageNum = query.get('signageNum')?"kiosk-"+query.get('signageNum'):"kioskWeb";

  const centerLong =  -115.1782890405586;
  const centerLat =  36.087886474666035;
  const xapi=null;

  const [lat, setLat] = useState(kioskData[kioskFid]?.lat || (latFromQuery ? latFromQuery :  36.088308032921276));
  const [long, setLong] = useState(kioskData[kioskFid]?.long || (longFromQuery ? longFromQuery : -115.1782890405586));
  const [rotation, setRotation] = useState(kioskData[kioskFid]?.rotation || (rotationFromQuery ? rotationFromQuery:0));
  const [zoom, setZoom] = useState(kioskData[kioskFid]?.zoom || (zoomFromQuery ? zoomFromQuery : 17));
  const [pitch, setPitch] = useState(kioskData[kioskFid]?.pitch || (pitchFromQuery ? pitchFromQuery: 65));
  const [bearing, setBearing] = useState(kioskData[kioskFid]?.bearing || (bearingFromQuery ? bearingFromQuery : -70));
  const [level, setLevel] = useState(kioskData[kioskFid]?.level || (levelFromQuery ? levelFromQuery: 0));
  const [building, setBuilding] = useState(kioskData[kioskFid]?.building || (buildingFromQuery ? buildingFromQuery : 13));
  const [visibleAIContainer, setVisibleAIContainer] = useState(visibleAiContainerFromQuery?(visibleAiContainerFromQuery==='true'):true);

  const [whereAmILevel, setWhereAmILevel] = useState(level);
  const [whereAmIBuilding, setWhereAmIBuilding] = useState(building);
  const [selectedFloor, setSelectedFloor] = useState(level);
  const [kioskLocation, setKioskLocation] = useState(1);

  const [eventStartDateData, setEventStartDateData] = useState({
    year: 2025,
    month: 7,
    day: eventStartDay
  });


  const [eventEndDateData, setEventEndDateData] = useState({
    year: 2025,
    month: 7,
    day:28
  });


  useEffect(() => {
    if (kioskFid && kioskData[kioskFid]) {
      const data = kioskData[kioskFid];
      setLat(data.lat ||  36.088308032921276);
      setLong(data.long || -115.1782890405586);
      setRotation(data.rotation || -1);
      setZoom(data.zoom || 17);
      setPitch(data.pitch || 65);
      setBearing(data.bearing || -70);
      setLevel(data.level || 0);
      setWhereAmILevel(level);
      setBuilding(data.building || 13);
      setWhereAmIBuilding(building);
    }
  }, [kioskFid]);


  useEffect(() => {
    if (destFid && !hasPassedDestFidRef.current) {
      // Call any function or set up as needed for the first time `destFid` is passed
      hasPassedDestFidRef.current = true;
    }
  }, [destFid]);

  
  const showPopup = (poi, coordinates, cleanPopup = true,isMapClick=false) => {
    if (!poi) {
      if(popupState.poi){
        handleResetView(cleanPopup,isMapClick);
      } 
      const navigationViewController = window.PointrWebSDK.MapWidget.getInstance()?.getUiController().getNavigationViewController();
      window.PointrWebSDK.MapWidget.getInstance().getUiController().getMapViewController().hideRoute();
      navigationViewController.close();
      setPopupState({ poi: null, coordinates: null });
    
     
    } else {
      setPopupState({ poi, coordinates: (poi?.geometry?.type === 'Point') ? poi.geometry.coordinates : calculateMidPoint(poi.geometry.coordinates[0]) });
    }
  };
  const showCiscoSpacesPopup = () => {
    setCiscoSpacesPopup(true);
  };
  useEffect(() => {
    const interval = setInterval(() => {
      if (window.PointrWebSDK) {
        setIsPointrSDKLoaded(true);
        clearInterval(interval);
      }
    }, 100); // Check every 100ms

    return () => clearInterval(interval);
  }, []);
  // Handler to hide the popup
  const hidePopup = () => {
    setPopupState({ poi: null, coordinates: null });
    handleResetView();
    setTriggerDirectionsPopup(false);
  };
  
  const badgeQrScanSuccess = async (badgeId) => {
    try{
    console.log("Badge Id received " + badgeId);
    showPopup(null, null, true, false);
    setQRScanBadgeInfoInput(null);
    let accessToken = await CiscoAiAuth.fetchAccessTokenForAttendee(eventId, badgeId);
    const attendeeInfo = await fetchAttendeeInfo(accessToken, eventId, { badgeId: badgeId },teaLogService);
    const userKey=attendeeInfo?.[0]?.userKey;     
    //const userFullName=attendeeInfo?.[0]?.firstName+" "+attendeeInfo?.[0]?.lastName;
    //const firstName=attendeeInfo?.[0]?.firstName
    //const lastName=attendeeInfo?.[0]?.lastName     
    //const dashboardPackage=attendeeInfo?.[0]?.dashboardPackage;     


    teaLogService.overrideConfiguration({"data":{"user":attendeeInfo?.[0]}})
    teaLogService.teaLogBadgeScanAction(badgeId,kioskLocation?kioskLocation:1);
    sendTrackingEventForCiscoAI(tenantId, attendeeInfo?.[0].userKey, "Badge Scan",eventName,attendeeInfo?.[0]);
    const recommendedEvents = await fetchRecommendedEvents(accessToken,eventId,attendeeInfo,"",constraintsLookUp,teaLogService);
    if(recommendedEvents == undefined|| recommendedEvents?.length==0){
      setShowFailedPopupCard(true);
      setShowPopupCard(false);
      return;
    }
    setRecommendationsInfo(recommendedEvents);
    setAttendeeInfo(attendeeInfo);
    setAttendeeUserToken(accessToken)
    setShowPopupCard(false);
    setShowAICard(true);
    }catch(error){
      console.log("Exception occured while processing badge");
      console.log(error)
      setShowFailedPopupCard(true);
      setShowPopupCard(false);
    }
    
  }

  useEffect(() => {
    // Fetch data from the API only once when the component mounts
    const getZones = async () => {
      try {

        const data = await fetchGsxData(tenantId);
        console.log("gsx" + data);
        if(data.zones){
          setIsZonesInfoPopulated(true);
        }
        setZonesInfo(data.zones);
        setHubwalksInfo(data.hubWalks);
        setFacilitiesData(data.facilities);

      } catch (err) {

        console.log(err);

      }
    };

    getZones();
    intialiseQRScannerModule();
  }, []);
  // Simulate map loading
  useEffect(() => {
    // Simulate a delay for the map loading
    const mapLoadTimeout = setTimeout(() => {
      setIsMapLoaded(true);
      document.title = '2025 Cisco Live';
    }, 5000); // Adjust the delay as needed

    return () => clearTimeout(mapLoadTimeout);
  }, []);

  useEffect(() => {
    let intervalId;
  
    const fetchPoiUntilFound = async () => {
      if (map && destFid) {
        const poi = await map.getPoiManager().get(destFid);
        if (poi) {
          // Uncomment this line when ready to show the popup
          const uiController = map.getUiController();
          const mapViewController = uiController.getMapViewController();
          mapViewController.setLevel(poi.properties.lvl);
          mapViewController.highlightPoi(poi);
           showPopup(poi, poi?.geometry?.type === 'Point' ? poi.geometry.coordinates : calculateMidPoint(poi.geometry.coordinates[0]),false,false);
           clearInterval(intervalId); // Stop checking once the poi is found
        }
        
      }
    };
  
    // Set up polling to run fetchPoiUntilFound every 500ms (adjust as needed)
    intervalId = setInterval(fetchPoiUntilFound, 5000);
  
    return () => clearInterval(intervalId); // Clear interval on component unmount or when dependencies change
  }, [map, destFid]);


  useEffect(() => {
    const eventTypes = ["click", "mousemove", "keypress", "wheel", "gesturestart", "gesturechange", "gestureend", "touchmove", "touchstart", "touchend"];

    eventTypes.forEach(eventType => {
      window.addEventListener(eventType, handleActivity);
    });

    return () => {
      eventTypes.forEach(eventType => {
        window.removeEventListener(eventType, handleActivity);
      });
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, []);

  useEffect(() => { }, [isActive]);


  const handleActivity = (event) => {
    setIsActive(true);
    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      setIsActive(false);
      console.log("No activity detected for 2 minutes." + event.type);
    }, 180000); // 3 minutes
  };


  const handleSearch = async (searchInput) => {
    hidePopup();
    const uiController = map.getUiController();
    const mapViewController = uiController.getMapViewController();
    const mapView = mapViewController.getView();
    mapView.setLayoutProperty("rmaps-symbol_selected_ptr", 'icon-image', 'green_marker');

    console.log(searchInput);
    let valueAfterTilde;
    let poiFid = searchInput?.fId;
    if (searchInput?.type === 'session') {
      poiFid = searchInput?.poiFId;
    }else if((searchInput?.type === 'exhibitor')){
      poiFid = searchInput?.poiFId;
    }
    if (poiFid?.includes('~')) {
      valueAfterTilde = poiFid.split('~')[1];
    } else {
      valueAfterTilde = poiFid;
    }
    const poi = await map.getPoiManager().get(valueAfterTilde);
    if (poi) {
      map.unhighlight();
      mapViewController.setLevel(poi.properties.lvl);
      mapViewController.highlightPoi(poi);
      map.hidePoiDetails(poi);

      if (poi?._geometry?.coordinates[0]) {
        const latLong = (poi.geometry.type === 'Point') ? {
          lat: poi.geometry.coordinates[1],
          lng: poi.geometry.coordinates[0]
        } : calculateMidPoint(poi?._geometry?.coordinates[0]);

        //updateLayerFilterForSingleFeature(mapView, searchInput);
        mapView.map.flyTo({
          center: [latLong.lng, latLong.lat],
          zoom: 20, pitch: pitch, bearing: bearing, speed: 0.4
        });
        if (searchInput.type === 'session') {
          poi._properties.isSession = true;
          poi._properties.sessionsInfo = [searchInput];
          poi._properties.sessionStart= searchInput?.utcStartTime;

        }
        showPopup(poi, latLong);
        manageLayers(map?.getUiController().getMapViewController().getView(),poi?._properties?.bid,poi?._properties?.lvl)
        if(poi?._properties?.lvl==whereAmILevel){
          markCurrentPosition(map, long, lat, rotation, true, pitch, bearing, whereAmIBuilding, whereAmILevel, whereAmIBuilding, whereAmILevel, 20.5, 150.091301692798277e-8);
          mapView.map.flyTo({
            center: [latLong.lng, latLong.lat],
            zoom: 20, pitch: pitch, bearing: bearing, speed: 0.4
          });
        }else{
          removeCurrentPosition(map.getUiController().getMapViewController().getView());
        }
      }
    }
  };

  useEffect(() => {
    if (searchInput) {
      handleSearch(searchInput);
    }
  }, [searchInput]);

  const intialiseQRScannerModule = async () =>{
      console.log("Initiliazing the QR code scanner");
      let hashes = getHashes(["username", "password", "ipAddress", "location"]);
      setKioskLocation(hashes?.location? hashes.location : 1)
      await initializeXAPIScanner(window.jsxapi,hashes,setQRScanBadgeInfoInput);
  }

  useEffect(() => {
    console.log("QR Input received "+qrScanBadgeInfoInput);
    if (qrScanBadgeInfoInput) {
      if(!showAICard && !showFaqList /**&& showPopupCard*/){
        badgeQrScanSuccess(qrScanBadgeInfoInput);
        showAiLoader(true);
        setIsActive(true);
        setQRScanBadgeInfoInput(null);
      }else{
         console.error("Already Attendee is using the AI or no yet launched")
         setQRScanBadgeInfoInput(null);
      }
    }
  }, [qrScanBadgeInfoInput]);


  useEffect(() => {
    console.log("showAiLoader received "+aiLoader);
    if (aiLoader) {
      showLoader();
    }else{
      hideLoader();
    }
  }, [aiLoader]);


  useEffect(() => {
    console.log("showAICard received "+showAICard);
    if (!showAICard) {
      setShowFaqList(0);
      setQRScanBadgeInfoInput(null);
    }
  }, [showAICard]);

  // Function to create and show the loader
  function showLoader() {
    // Create and style the overlay element
    const overlay = document.createElement("div");
    overlay.id = "ai-overlay"; // Set the id
    overlay.className = "ai-overlay"; // Set the class name
    document.body.appendChild(overlay);

    // Create and style the loader element
    const loader = document.createElement("div");
    loader.id = "ai-loader"; // Set the id
    loader.className = "ai-loader"; // Set the class name
    document.body.appendChild(loader);

    // Display the loader and overlay
    if (loader && overlay) {
      overlay.style.display = "block";
      loader.style.display = "block";
    }
  }


  // Function to hide and remove the loader
  function hideLoader() {
    const loader = document.getElementById("ai-loader");
    const overlayloader = document.getElementById("ai-overlay");

    if (loader && overlayloader) {
      loader.style.display = "none";
      document.body.removeChild(loader);

      overlayloader.style.display = "none";
      document.body.removeChild(overlayloader);

    }
  }
  const handleResetView = (cleanPopup = false,isMapClick=false) => {
    setShowAICard(false);
    setShowFaqList(false);
    setTriggerDirectionsPopup(false);
    setSelectedFloor(whereAmILevel)
    handleReset(long ? long : 4.888230470000053, lat ? lat : 52.341674505000015, rotation ? rotation : -4.5, 18, true, cleanPopup,isMapClick, pitch, bearing, whereAmIBuilding, whereAmILevel, centerLong, centerLat, 150.091301692798277e-8);
  };


  const handleResetViewButton = (cleanPopup = false) => {
    setPopupState({ poi: null, coordinates: null });
    handleResetView();
  };

  const handleResetViewButtonInitialZoom = (cleanPopup = false) => {
    setPopupState({ poi: null, coordinates: null });
    setSelectedFloor(whereAmILevel)
    handleResetView();
  //handleReset(long ? long : -115.1782890405586, lat ? lat : 36.088308032921276, rotation ? rotation : -4.5, 17, true, cleanPopup,false, pitch, bearing, building, level);

    const uiController = map.getUiController();
    const mapViewController = uiController.getMapViewController();
    const mapView = mapViewController.getView();
    mapView.map.flyTo({
      center: [long, lat],
      zoom: 18,
      bearing: bearing,
      pitch: pitch,
      speed:0.4
    });
  };

  return (
    <div className="main-container">

      {isPointrSDKLoaded && <MapComponent showPopup={showPopup} tenantId={tenantId}
        locationId={locationId} siteExternalIdentifier={siteExternalIdentifier} lat={lat} long={long} zoom={zoom} pitch={pitch} bearing={bearing} rotation={rotation} eventName = {eventName} whereAmILevel={parseInt(whereAmILevel)} whereAmIBuilding={parseInt(whereAmIBuilding)} defaultBuilding={parseInt(building)} defaultLevel={parseInt(level)} setBuilding={setBuilding} setLevel={setLevel} timeZone={timeZone} eventStartDateData={eventStartDateData} centerLatLong={[centerLong,centerLat]}
        setTriggerDirectionsPopup={setTriggerDirectionsPopup} signageNum={signageNum}/>}
      {isMapLoaded && (
        
        <>
          {handleWhereAmI(map,long,lat,rotation,pitch,bearing,whereAmILevel, whereAmIBuilding,20.8, 150.091301692798277e-8)}
          <HeaderContainer
            showCiscoSpacesPopup={showCiscoSpacesPopup} timeZoneCity={timeZoneCity} 
            eventStartDateData = {eventStartDateData} eventEndDateData={eventEndDateData}  
            handleResetView={handleResetViewButton}  eventLogoName={eventLogoName} 
            eventName={eventName} defaultLevel={parseInt(level)} 
            defaultBuilding = {parseInt(building)} setBuilding={setBuilding} 
            setLevel={setLevel} pitch={pitch} 
            bearing={bearing} lat={lat} long={long} 
            rotation={rotation}
            eventTitle={eventTitle}
            eventSubTitle={eventSubTitle}
            eventTimeZone={timeZone}
            defaultBuildingTitle={eventTitle}
            buildingInfo={buildingInfo}/>
          {zonesInfo &&
            <LeftContainer
              zoneData={zonesInfo} showPopup={showPopup} hidePopup={hidePopup} tenantId={tenantId}
              locationId={locationId} qrCodeExpiresAt={qrCodeExpiresAt}
              whereAmIBuilding={whereAmIBuilding}
              whereAmILevel={whereAmILevel}
              defaultLevel={parseInt(level)} 
              defaultBuilding = {parseInt(building)}
              handleResetView={handleResetViewButton}
              setBuilding={setBuilding}
              setLevel={setLevel} 
              lat={lat}
              long={long}
              rotation={rotation}
              pitch={pitch}
              bearing={bearing}
              showLevelSelector={false}
              isZonesInfoPopulated={isZonesInfoPopulated}
              isDestFidPopulated={destFid?true:false}
              selectedFloor={selectedFloor}
              setSelectedFloor={setSelectedFloor}
              buildingInfo={buildingInfo}
              defaultBuildingTitle={defaultBuildingTitle}
              centerLatLong={[centerLong,centerLat]}
              eventName={eventName}
              floorColourMapping={floorColourMapping}
              floorNameMapping={floorNameMapping}
              signageNum={signageNum}
               />}
          {isPointrSDKLoaded && 
          <RightContainer
            hubwalksData={hubwalksInfo} 
            facilitiesData={facilitiesData} 
            pitch={pitch} 
            bearing={bearing} 
            centerLong={centerLong} 
            centerLat={centerLat}
            visibleAIContainer={visibleAIContainer}
            eventId={eventId}
            tenantId={tenantId}
            setShowPopupCard={setShowPopupCard}
            showAICard={showAICard}
            setShowAICard={setShowAICard}
            showPopup={showPopup}
            recommendationsInfo={recommendationsInfo}
            setRecommendationsInfo={setRecommendationsInfo}
            attendeeUserToken={attendeeUserToken}
            attendeeInfo={attendeeInfo}
            constraintsLookUp={constraintsLookUp}
            teaLogService={teaLogService}
            setShowFaqList={setShowFaqList}
            showFaqList={showFaqList}
            setTriggerDirectionsPopup={setTriggerDirectionsPopup}
            triggerDirectionsPopup={triggerDirectionsPopup}
            setPopupState={setPopupState}
            showAiLoader={showAiLoader}
            timeZoneDiff={timeZoneDiff}
            />}
          {(!isActive &&
            /**<CountdownTimer
              initialMinutes={0}
              initialSeconds={10}
              resetTimer={isActive} // Pass isActive as a prop to reset the timer
              showPopup={showPopup}
            />*/
            <Screensaver inactivityTimeout={1000} flipInterval={3000} showPopup={showPopup} ciscoSpacesPopupImage={ciscoSpacesPopupImage} lat={lat} long={long} zoom={zoom} rotation={rotation} pitch={pitch} bearing={bearing} whereAmILevel={whereAmILevel} centerLong={centerLong} centerLat={centerLat} setShowAICard={setShowAICard} setShowPopupCard={setShowPopupCard} setShowSearch={setShowSearch}/>

          )}
          {(showFaqList==1) && <AIFAQListContainer setShowFaqList={setShowFaqList} showFaqList={showFaqList} setShowAICard={setShowAICard} showAICard={showAICard} setShowPopupCard={setShowPopupCard}/>}
          {showSearch && (
            <SearchPopup
              setSearchInput={setSearchInput}
              setShowSearch={setShowSearch}
              map={map}
              tenantId={tenantId}
              placeholder={"Search for points of interest and other facilities"}
              showCategories={true}
              timeZoneDiff={timeZoneDiff}
              timeZone={timeZone}
              eventStartDateData={eventStartDateData}
            />
          )}
          {showPopupCard && (
            <div className="ai-popup-overlay">
              <div className="ai-popup-overlay-popup">
                <div className="ai-popup-overlay-popup-card">
                 
                  <img src={ciscoAILogo} class="ai-popup-overlay-popup-card-logo" />
                  <div className="ai-popup-overlay-popup-card-logo-name">
                  You have activated <br/>Cisco AI Assistant.
                  </div>
                  <div className="ai-popup-overlay-popup-card-title">
                  Now, scan the front of your<br/>badge on the scanner to begin<br/>your customized journey.​
                  </div>
                  <img src={ciscoAIQrPlaceHolderLogo} className="ai-popup-overlay-popup-card-qr-place-holder"  onClick={() => {badgeQrScanSuccess("1740685683581001Z0Vh") }} />
                  <div className="ai-popup-overlay-popup-card-bottom-button">
                  <img src={ciscoHelpbutton} className="ai-popup-overlay-popup-card-bottom-button-help"  onClick={() => {setShowPopupCard(false);setShowFailedPopupCard(false); setShowFaqList(1); }}/>

                  <img src={ciscoClosebutton} className="ai-popup-overlay-popup-card-bottom-button-close" onClick={() => setShowPopupCard(false)}/>
                  </div>
                </div>
              </div>
            </div>
          )}
           {showFailedPopupCard && (
            <div className="ai-popup-overlay">
              <div className="ai-popup-overlay-popup">
                <div className="ai-popup-overlay-popup-card">
                 
                  <img src={ciscoAILogo} class="ai-popup-overlay-popup-card-logo" />
                  <div className="ai-popup-overlay-popup-card-logo-name">
                  You have activated <br/>Cisco AI Assistant.
                  </div>
                  <div className="ai-popup-overlay-popup-card-title">
                  There was an error<br/>scanning your badge.​
                  </div>
                  <img src={ciscoAIQrPlaceHolderFailedLogo} className="ai-popup-overlay-popup-card-qr-place-holder"/>
                  <div className="ai-popup-overlay-popup-card-bottom-scan-again-button" onClick={()=>{ setShowFailedPopupCard(false); setShowPopupCard(true);}}>
                    Scan again
                  </div>

                  <div className="ai-popup-overlay-popup-card-bottom-button">
                  <img src={ciscoHelpbutton} className="ai-popup-overlay-popup-card-bottom-button-help"  onClick={() => {setShowPopupCard(false); setShowFailedPopupCard(false); setShowFaqList(1)}}/>

                  <img src={ciscoClosebutton} className="ai-popup-overlay-popup-card-bottom-button-close" onClick={() => {setShowPopupCard(false); setShowFailedPopupCard(false);}}/>
                  </div>
                </div>
              </div>
            </div>
          )}
          {popupState.poi && (
            <CustomPopup
              poi={popupState.poi}
              coordinates={popupState.coordinates}
              tenantId={tenantId}
              locationId={getLocationId(popupState.poi)}
              onCancel={hidePopup}
              setPopupState={setPopupState}
              source={"poiClick"}
              lat={lat}
              long={long}
              building={building}
              level={level}
              rotation={rotation}
              bearing={bearing}
              pitch={pitch}
              whereAmIBuilding={whereAmIBuilding}
              whereAmIlevel={whereAmILevel}
              qrCodeExpiresAt={qrCodeExpiresAt}
              destFid={hasPassedDestFidRef.current ? undefined : destFid} 
              setBuilding={setBuilding}
              setLevel={setLevel}
              eventStartDate={eventStartDateData}
              eventTimeZone={timeZone}
              setSelectedFloor={setSelectedFloor}
              triggerDirectionsPopup={triggerDirectionsPopup}
              setTriggerDirectionsPopup={setTriggerDirectionsPopup}
              signageNum={signageNum}
            />
          )}
          {ciscoSpacesPopup && (
            <div className="cisco-spaces-popup-overlay" >
              <div className="cisco-spaces-popup-overlay">
                <div className="cisco-spaces-popup-overlay-popup">
                  <img src={ciscoSpacesPopupIcon} alt="Popup Content" class="cisco-spaces-popup-overlay-image" />
                  <div className="cisco-spaces-popup-overlay-close" onClick={() => setCiscoSpacesPopup(false)}>
                    <svg width="44" height="44" viewBox="0 0 45 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <g clip-path="url(#clip0_11306_4187)">
                        <circle cx="22.5477" cy="22.1922" r="21.1342" stroke="white" stroke-width="0.98722" />
                        <path d="M29.4141 26.9647L24.6432 22.1929L29.4141 17.4216L27.3198 15.3271L22.5486 20.0983L17.7775 15.3271L15.683 17.4216L20.4544 22.1929L15.6821 26.9647L17.7764 29.0589L22.5486 24.287L27.3198 29.0589L29.4141 26.9647Z" fill="white" />
                      </g>
                      <defs>
                        <clipPath id="clip0_11306_4187">
                          <rect width="43.2556" height="43.2556" fill="white" transform="translate(0.919922 0.564453)" />
                        </clipPath>
                      </defs>
                    </svg>
                  </div>
                </div>

              </div>
            </div>
          )}

          { aiLoader && <div  class="ai-overlay" id="ai-overlay" >
                    <div class="ai-loader" id="ai-loader" ></div>
                </div>}
          <FooterContainer
            setShowSearch={setShowSearch}
            handleResetView={handleResetViewButtonInitialZoom}
            long={long}
            lat={lat}
            rotation={rotation}
            pitch={pitch}
            bearing={bearing}
            whereAmIBuilding={parseInt(whereAmIBuilding)}
            whereAmILevel={parseInt(whereAmILevel)}
            setSelectedFloor={setSelectedFloor}
          />
        </>
      )}
    </div>
  );
};

export default CiscoGSX2025MainContainer;
